import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function PreviewButton({ onClick, disabled = false }) {
    return (
        <Button
            data-cy="preview-button"
            onClick={onClick}
            disabled={disabled}
            startIcon={<Iconify icon={"mdi:book-open"} />}
        >
            Preview Changes
        </Button>
    )
}
